import type { RatingState } from "@esgt/event-store"

export const isRatingEditable = (ratingState: RatingState): boolean => {
  return ratingState.phase !== "ABORTED" && ratingState.phase !== "COMPLETED"
}
